const hawaiiData = [
    {
    srcXL: require('../../assets/images/Hawaii/XL/trees.webp'),
    srcLG: require('../../assets/images/Hawaii/LG/trees.webp'),
    srcSM: require('../../assets/images/Hawaii/SM/trees.webp'),
    alt: "Trees",
  },
  {
    srcXL: require('../../assets/images/Hawaii/XL/beach.webp'),
    srcLG: require('../../assets/images/Hawaii/LG/beach.webp'),
    srcSM: require('../../assets/images/Hawaii/SM/beach.webp'),
    alt: "beach",
  },
  {
    srcXL: require('../../assets/images/Hawaii/XL/beachPeople.webp'),
    srcLG: require('../../assets/images/Hawaii/LG/beachPeople.webp'),
    srcSM: require('../../assets/images/Hawaii/SM/beachPeople.webp'),
    alt: "beach with tourists",
  },
  {
     srcXL: require('../../assets/images/Hawaii/XL/temple.webp'),
     srcLG: require('../../assets/images/Hawaii/LG/temple.webp'),
     srcSM: require('../../assets/images/Hawaii/SM/temple.webp'),
     alt: "Temple",
   },
   {
      srcXL: require('../../assets/images/Hawaii/XL/highway.webp'),
      srcLG: require('../../assets/images/Hawaii/LG/highway.webp'),
      srcSM: require('../../assets/images/Hawaii/SM/highway.webp'),
      alt: "Highway",
   },
   {
      srcXL: require('../../assets/images/Hawaii/XL/hike.webp'),
      srcLG: require('../../assets/images/Hawaii/LG/hike.webp'),
      srcSM: require('../../assets/images/Hawaii/SM/hike.webp'),
      alt: "Hike",
   },
   {
      srcXL: require('../../assets/images/Hawaii/XL/mountains.webp'),
      srcLG: require('../../assets/images/Hawaii/LG/mountains.webp'),
      srcSM: require('../../assets/images/Hawaii/SM/mountains.webp'),
      alt: "Hike",
   },
   {
      srcXL: require('../../assets/images/Hawaii/XL/treesForest.webp'),
      srcLG: require('../../assets/images/Hawaii/LG/treesForest.webp'),
      srcSM: require('../../assets/images/Hawaii/SM/treesForest.webp'),
      alt: "Trees in the forest",
   }
];

const NYCData = [
  {
     srcXL : require('../../assets/images/Nyc/XL/car.webp'),
     srcLG : require('../../assets/images/Nyc/LG/car.webp'),
     srcSM : require('../../assets/images/Nyc/SM/car.webp'),
     alt : "Car",
  },
  {
     srcXL : require('../../assets/images/Nyc/XL/highscrapper.webp'),
     srcLG : require('../../assets/images/Nyc/LG/highscrapper.webp'),
     srcSM : require('../../assets/images/Nyc/SM/highscrapper.webp'),
     alt : "Highscrapper",
  },
   {
     srcXL : require('../../assets/images/Nyc/XL/highscrapper2.webp'),
     srcLG : require('../../assets/images/Nyc/LG/highscrapper2.webp'),
     srcSM : require('../../assets/images/Nyc/SM/highscrapper2.webp'),
     alt : "Highscrapper 2",
  },
  {
     srcXL : require('../../assets/images/Nyc/XL/bridge.webp'),
     srcLG : require('../../assets/images/Nyc/LG/bridge.webp'),
     srcSM : require('../../assets/images/Nyc/SM/bridge.webp'),
     alt : "Bridge",
  },
  {
     srcXL : require('../../assets/images/Nyc/XL/subway.webp'),
     srcLG : require('../../assets/images/Nyc/LG/subway.webp'),
     srcSM : require('../../assets/images/Nyc/SM/subway.webp'),
     alt : "Subway",
  },
  {
     srcXL : require('../../assets/images/Nyc/XL/statue.webp'),
     srcLG : require('../../assets/images/Nyc/LG/statue.webp'),
     srcSM : require('../../assets/images/Nyc/SM/statue.webp'),
     alt : "Statue",
  },
  {
     srcXL : require('../../assets/images/Nyc/XL/entranceSubway.webp'),
     srcLG : require('../../assets/images/Nyc/LG/entranceSubway.webp'),
     srcSM : require('../../assets/images/Nyc/SM/entranceSubway.webp'),
     alt : "Entrance Subway",
  }
];

const mtlData = [
   {
     srcXL : require('../../assets/images/Mtl/XL/bridge.webp'),
     srcLG : require('../../assets/images/Mtl/LG/bridge.webp'),
     srcSM : require('../../assets/images/Mtl/SM/bridge.webp'),
     alt : "Bridge",
  },
  {
     srcXL : require('../../assets/images/Mtl/XL/buildings.webp'),
     srcLG : require('../../assets/images/Mtl/LG/buildings.webp'),
     srcSM : require('../../assets/images/Mtl/SM/buildings.webp'),
     alt : "Buildings",
  },
  {
     srcXL : require('../../assets/images/Mtl/XL/clock.webp'),
     srcLG : require('../../assets/images/Mtl/LG/clock.webp'),
     srcSM : require('../../assets/images/Mtl/SM/clock.webp'),
     alt : "Clock",
  },
  {
     srcXL : require('../../assets/images/Mtl/XL/darkStreet.webp'),
     srcLG : require('../../assets/images/Mtl/LG/darkStreet.webp'),
     srcSM : require('../../assets/images/Mtl/SM/darkStreet.webp'),
     alt : "Dark Street",
  },
  {
     srcXL : require('../../assets/images/Mtl/XL/clock2.webp'),
     srcLG : require('../../assets/images/Mtl/LG/clock2.webp'),
     srcSM : require('../../assets/images/Mtl/SM/clock2.webp'),
     alt : "Clock",
  },
  {
     srcXL : require('../../assets/images/Mtl/XL/foggyLight.webp'),
     srcLG : require('../../assets/images/Mtl/LG/foggyLight.webp'),
     srcSM : require('../../assets/images/Mtl/SM/foggyLight.webp'),
     alt : "Light",
  },
  {
     srcXL : require('../../assets/images/Mtl/XL/gas.webp'),
     srcLG : require('../../assets/images/Mtl/LG/gas.webp'),
     srcSM : require('../../assets/images/Mtl/SM/gas.webp'),
     alt : "Gas Station",
  },
  {
     srcXL : require('../../assets/images/Mtl/XL/highway.webp'),
     srcLG : require('../../assets/images/Mtl/LG/highway.webp'),
     srcSM : require('../../assets/images/Mtl/SM/highway.webp'),
     alt : "Night Highway",
  },
  {
     srcXL : require('../../assets/images/Mtl/XL/sphere.webp'),
     srcLG : require('../../assets/images/Mtl/LG/sphere.webp'),
     srcSM : require('../../assets/images/Mtl/SM/sphere.webp'),
     alt : "Sphere",
  },
  {
     srcXL : require('../../assets/images/Mtl/XL/tim.webp'),
     srcLG : require('../../assets/images/Mtl/LG/tim.webp'),
     srcSM : require('../../assets/images/Mtl/SM/tim.webp'),
     alt : "Tim Hortons",
  }
];



export default function getImgData() {
  return {
    hawaii : {data : hawaiiData , descId : "PHOTOGRAPHY.GENERAL_DESC_HAWAII"},
    newYork : {data :NYCData, descId : "PHOTOGRAPHY.GENERAL_DESC_NYC"},
    montreal : {data :mtlData, descId : "PHOTOGRAPHY.GENERAL_DESC_MTL"},
  }
}